import React from 'react';
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Alert, AlertDescription } from "../components/ui/alert";

const TestPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 flex items-center justify-center pt-24 pb-10 px-4">
        <div className="w-full max-w-md">
          <div className="bg-background rounded-2xl p-8 border border-border shadow-xl">
            <h2 className="text-2xl font-bold tracking-tight mb-4">Test Page</h2>
            <p className="mb-4">This is a test page to verify UI components are working correctly.</p>
            
            <Alert className="mb-6">
              <AlertDescription>This is a test alert</AlertDescription>
            </Alert>
            
            <div className="space-y-4">
              <div className="space-y-2">
                <label htmlFor="test" className="text-sm font-medium">Test Input</label>
                <Input id="test" placeholder="Test input" />
              </div>
              
              <Button>Test Button</Button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TestPage; 